import { useEffect, useState } from 'react'
import NavTitle from '../../../components/nav-title'
import TextNavTitle from '../../../components/TextNavTitle'
import CardCustom from '../../../components/custom/card-custom'
import {
  Button,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import { BsArrowClockwise, BsSearch } from 'react-icons/bs'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import NavRoleOrg from '../../../components/nav-role-org'
import { useSelector } from 'react-redux'
import { ExportExcelLip } from '../../../helper/exportExcelLip'
import { Controller, useForm } from 'react-hook-form'
import InputSearchCustom from '../../../components/custom/InputSearchCustom'
import excelImg from '../../../images/xlsFile.svg'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import styled from 'styled-components'
import TableSkeletonBody from '../../../components/custom/TableSkeletonBody'
import LabelCustomSmall from '../../../components/label-custom-small'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import cancelImg from '../../../images/Cancel.svg'
import ModalCancel from './ModalCancel'
import {
  exportReportLeaveFullAPI,
  getFileLeavesAPI,
  reportLeaveFullAPI
} from '../../../services/report/leave'
import Error_false from '../../../components/error/error-false'
import { fnDateEn } from '../../../helper/fnDateEn'
import UseLeaveTypeFull from '../../../hooks/use-leave-type'
import UseLeaveStatusFull from '../../../hooks/use-leave-status'
import { FaFileAlt } from 'react-icons/fa'
import BageStatusCustom from '../../../components/custom/BageStatusCustom'
import { fnColorStatus } from '../../../helper/fnColorStatus'

export default function ReportLeavePage() {
  const roleId = useSelector((state) => state.roleReducer.role)
  const [isLoading, setIsLoading] = useState(false)
  const [totalRow, setTotalRow] = useState(0)
  const [dataTable, setDataTable] = useState([])
  const totalLimits = 20
  const [bodyFilter, setBodyFilter] = useState()
  const [page, setPage] = useState(1)
  const leaveTypes = UseLeaveTypeFull()
  const leaveStatus = UseLeaveStatusFull()
  const [leaveType, setLeaveType] = useState()
  const [statusType, setStatusType] = useState()
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)

  useEffect(() => {
    const body = {
      page: 1,
      orgId: roleId
    }
    setPage(1)
    if (roleId) fnGetData(body)
  }, [roleId])

  const fnGetData = async (body) => {
    setIsLoading(true)
    setBodyFilter(body)
    const resp = await reportLeaveFullAPI(body)
    setIsLoading(false)
    if (!resp) return
    if (resp.status) {
      setDataTable(resp.result)
      setTotalRow(resp.totalRows)
    } else {
      Error_false(resp)
      setTotalRow(0)
      setDataTable([])
    }
  }

  const [isLoadExcel, setIsLoadExcel] = useState(false)
  const fnEportExcel = async (body) => {
    setIsLoadExcel(true)
    const resp = await exportReportLeaveFullAPI(body)
    setIsLoadExcel(false)

    if (!resp) return
    if (resp.status) {
      const formatDate = (date) => (date ? fnDateEn(date).format('DD/MM/YYYY') : '-')
      const formatTime = (time, date) => {
        if (time) return time
        return date ? fnDateEn(date).format('HH:mm') : '-'
      }

      const dataExcel = resp.result.map((d, i) => {
        return {
          num: i + 1,
          code: d.code,
          nameFullTh: d.nameFullTh,
          nicknameTh: d.nicknameTh,
          org: d.org,
          group: d.group,
          division: d.division,
          department: d.department,
          team: d.team,
          position: d.position,
          location: d.location,
          project: d.project,
          docNo: d.docNo,
          leaveType: d.leaveType,
          leaveTime: d.leaveTime,
          leaveStartDate: formatDate(d.leaveStartDate || d.startDate),
          leaveStartTime: formatTime(d.leaveStartTime, d.startDate),
          leaveEndDate: formatDate(d.leaveEndDate || d.endDate),
          leaveEndTime: formatTime(d.leaveEndTime, d.endDate),
          leaveDay: d.leaveDay,
          day: d.day,
          hour: d.hour,
          minutes: d.minutes,
          leaveReason: d.leaveReason,
          leaveStatus: d.leaveStatus,
          requester: d.requester,
          requestDate: formatDate(d.requestDate),
          approvedBy: d.approvedBy,
          approvedDate: formatDate(d.approvedDate)
        }
      })
      const header = [
        'No.',
        'Employee Code',
        'Name',
        'Nickname',
        'Org.',
        'Group',
        'Division',
        'Department',
        'Team',
        'Position',
        'Location',
        'Project',
        'Doc No.',
        'Leave Type',
        'Duration Type',
        'Leave Start Date',
        'Leave Start Time',
        'Leave End Date',
        'Leave End Time',
        'Leave Day',
        'Day',
        'Hour',
        'Minutes',
        'Reason',
        'Status',
        'Requester',
        'Request Date',
        'Approver',
        'Approved Date'
      ]
      ExportExcelLip({
        header,
        dataExcel,
        fileName: `Report-Leave-${fnDateEn().format('YYYYMMDDHHmmss')}`
      })
    } else {
      Error_false(resp)
    }
  }

  const fnExportExcel = () => {
    const d = bodyFilter
    const body = {
      orgId: d.orgId,
      docNo: d.docNo,
      insertBy: d.insertBy,
      leaveStatusId: d.leaveStatusId,
      leaveTypeId: d.leaveTypeId,
      reportTo: d.reportTo,
      job: d.job,
      team: d.team,
      startDate: d.startDate,
      endDate: d.endDate
      // orgId: roleId
    }
    fnEportExcel(body)
  }

  const { control, setValue, reset, handleSubmit } = useForm({})
  const onClearSearch = (d) => {
    const body = {
      ...d,
      page: 1,
      orgId: roleId
    }
    setPage(1)
    fnGetData(body)
  }
  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      orgId: roleId,
      docNo: d.docNo,
      insertBy: d.username,
      reportTo: d.reportTo,
      job: d.job,
      team: d.team,
      startDate: d.startDate ? fnDateEn(d.startDate).format('YYYY-MM-DD') : '',
      endDate: d.endDate ? fnDateEn(d.endDate).format('YYYY-MM-DD') : ''
    }
    setPage(1)
    fnGetData(body)
  }

  const [showCancel, setShowCancel] = useState({ isShow: false, data: null })

  const fnGetFile = async (leaveDetailId) => {
    const resp = await getFileLeavesAPI({ leaveDetailId })
    if (!resp) return
    if (resp.status) {
      window.open(resp.result, '_blank')
    } else {
      Error_false(resp)
    }
  }
  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Leave</TextNavTitle>
      </NavTitle>
      <NavRoleOrg />
      <Col xl={12}>
        <div className="p-3 bg-white rounded-top-3 shadow-sm">
          <Row className="g-3">
            <Col md={2}>
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>Doc No.</LabelCustomSmall>
                <Controller
                  name={'docNo'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch({
                            ...bodyFilter,
                            docNo: ''
                          })
                        }
                      }}
                      placeholder=""
                    />
                  )}
                />
              </Form>
            </Col>
            <Col md={2}>
              <LabelCustomSmall>Type</LabelCustomSmall>
              <AutocompleteCustom
                options={leaveTypes}
                value={leaveType}
                isClearable={true}
                onChange={(e) => {
                  const body = {
                    ...bodyFilter,
                    page: 1,
                    leaveTypeId: e ? e.value : ''
                  }
                  setLeaveType(e)
                  setPage(1)
                  fnGetData(body)
                }}
              />
            </Col>

            <Col md={2} className="">
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>Start Date</LabelCustomSmall>

                <Controller
                  name={'startDate'}
                  control={control}
                  render={({ field: { onChange, value = null } }) => (
                    <CustomDatePicker
                      isClearable={true}
                      value={value}
                      maxDate={endDate}
                      onChange={(d) => {
                        onChange(d)

                        setStartDate(d ? d : null)
                      }}
                      showYearDropdown
                      showMonthDropdown
                    />
                  )}
                />
              </Form>
            </Col>
            <Col md={2} className="">
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>End Date</LabelCustomSmall>

                <Controller
                  name={'endDate'}
                  control={control}
                  render={({ field: { onChange, value = null } }) => (
                    <CustomDatePicker
                      isClearable={true}
                      value={value}
                      minDate={startDate}
                      onChange={(d) => {
                        onChange(d)

                        setEndDate(d ? d : null)
                      }}
                      showYearDropdown
                      showMonthDropdown
                    />
                  )}
                />
              </Form>
            </Col>
            <Col md={2} className="">
              <LabelCustomSmall>Status</LabelCustomSmall>
              <AutocompleteCustom
                isClearable={true}
                options={leaveStatus}
                value={statusType}
                onChange={(e) => {
                  const body = {
                    ...bodyFilter,
                    page: 1,
                    leaveStatusId: e ? e.value : ''
                  }
                  setStatusType(e)
                  setPage(1)
                  fnGetData(body)
                }}
              />
            </Col>
            <Col md={2}>
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>Username</LabelCustomSmall>
                <Controller
                  name={'username'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch({
                            ...bodyFilter,
                            insertBy: ''
                          })
                        }
                      }}
                      placeholder="Search"
                    />
                  )}
                />
              </Form>
            </Col>
            <Col md={2}>
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>Group / Department</LabelCustomSmall>
                <Controller
                  name={'job'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch({
                            ...bodyFilter,
                            job: ''
                          })
                        }
                      }}
                      placeholder="Search"
                    />
                  )}
                />
              </Form>
            </Col>
            <Col md={2}>
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>Team</LabelCustomSmall>
                <Controller
                  name={'team'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch({
                            ...bodyFilter,
                            team: ''
                          })
                        }
                      }}
                      placeholder="Search"
                    />
                  )}
                />
              </Form>
            </Col>
            <Col md={2}>
              <Form className="from-search" onSubmit={handleSubmit(onSearch)}>
                <LabelCustomSmall>Report to</LabelCustomSmall>
                <Controller
                  name={'reportTo'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <InputSearchCustom
                      value={value}
                      onChange={(d) => {
                        onChange(d)

                        if (!d) {
                          onClearSearch({
                            ...bodyFilter,
                            reportTo: ''
                          })
                        }
                      }}
                      placeholder="Search"
                    />
                  )}
                />
              </Form>
            </Col>
            <Form
              onSubmit={handleSubmit(onSearch)}
              className="col-md-2 d-grid align-self-end"
            >
              <BoxFilter className="justify-content-end">
                <>
                  <Button className="btn-excel" type="submit">
                    <BsSearch />
                  </Button>
                  <Button
                    type="button"
                    className="btn-reflesh"
                    variant="light"
                    onClick={() => {
                      const body = {
                        page: 1,
                        orgId: roleId
                      }
                      setValue('docNo', '')
                      setValue('startDate', '')
                      setValue('endDate', '')
                      setValue('username', '')
                      setValue('job', '')
                      setValue('team', '')
                      setValue('reportTo', '')
                      setLeaveType(null)
                      setStatusType(null)
                      setPage(1)
                      reset()
                      fnGetData(body)
                    }}
                  >
                    <BsArrowClockwise />
                  </Button>
                </>
              </BoxFilter>
            </Form>
            <Col md={4} className="d-grid align-self-end">
              <BoxFilter className="justify-content-end">
                <Button
                  disabled={isLoadExcel}
                  className="btn-excel"
                  onClick={() => fnExportExcel()}
                >
                  {isLoadExcel ? (
                    'Loading...'
                  ) : (
                    <Image src={excelImg} style={{ width: '15px' }} />
                  )}
                </Button>
              </BoxFilter>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={2} className="my-auto small">
              <label
                className="my-auto fw-bold me-3"
                style={{
                  fontSize: '14px'
                }}
              >
                Total: {totalRow?.toLocaleString()}
              </label>
            </Col>

            <Col md={10} className="">
              {/* <BoxFilter className="justify-content-end">
                  <Button className="btn-excel" onClick={() => fnExportExcel()}>
                    <Image src={excelImg} style={{ width: '15px' }} />
                  </Button>
                </BoxFilter> */}
            </Col>
          </Row>
        </div>
        <CardCustom
          minHeight=""
          style={{
            height: 'calc(100vh - 330px)'
          }}
          className="d-flex justify-content-between "
        >
          <Table hover responsive>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px', zIndex: 1 }}
            >
              <tr className="fw-light font-title-table">
                <th>#</th>
                <th>ORG</th>
                <th>Doc No.</th>
                <th
                  style={{ minWidth: 90, maxWidth: 120, whiteSpace: 'nowrap' }}
                >
                  Emp Code
                </th>
                <th>Employee</th>
                <th
                  style={{ minWidth: 150, maxWidth: 200, whiteSpace: 'nowrap' }}
                >
                  ชื่อ - นามสกุล
                </th>
                <th
                  style={{ minWidth: 100, maxWidth: 150, whiteSpace: 'nowrap' }}
                >
                  Leave Type
                </th>
                <th
                  style={{ minWidth: 100, maxWidth: 150, whiteSpace: 'nowrap' }}
                >
                  Time to Leave
                </th>
                <th
                  style={{ minWidth: 100, maxWidth: 150, whiteSpace: 'nowrap' }}
                >
                  Leave Date
                </th>
                <th
                  style={{ minWidth: 100, maxWidth: 150, whiteSpace: 'nowrap' }}
                >
                  Leave Day
                </th>
                <th>Agent By</th>
                <th
                  style={{ minWidth: 250, maxWidth: 300, whiteSpace: 'nowrap' }}
                >
                  Reason
                </th>
                <th>Approver</th>
                <th
                  style={{ minWidth: 100, maxWidth: 150, whiteSpace: 'nowrap' }}
                >
                  Approved Date
                </th>
                <th>Status</th>
                <th>File</th>
                <th className="text-center">Cancel</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <>
                  <TableSkeletonBody colSpan={17} rowSpan={10} />
                </>
              ) : dataTable.length > 0 ? (
                dataTable.map((d, i) => (
                  <tr className="fw-light font-small-2 " key={i}>
                    <td> {page * totalLimits - totalLimits + i + 1}</td>
                    <td className="">
                      <div>{d.org}</div>
                    </td>
                    <td className="">
                      <div>{d.docNo}</div>
                    </td>
                    <td className="">
                      <div>{d.code}</div>
                    </td>
                    <td className="">{d.username}</td>
                    <td className="">{d.nameFullTh}</td>
                    <td className="">{d.leaveType} </td>

                    <td className="">{d.leaveTime}</td>
                    <td className="">
                      {fnDateEn(d.startDate).format('DD/MM/YYYY')} -{' '}
                      {fnDateEn(d.endDate).format('DD/MM/YYYY')}
                    </td>
                    <td className="">{d.leaveDay}</td>
                    <td className="">{d.agentBy}</td>
                    <td className="">{d.leaveReason}</td>
                    <td className="">{d.approvedBy}</td>
                    <td className="">
                      {d.approvedDate
                        ? fnDateEn(d.approvedDate).format('DD/MM/YYYY')
                        : '-'}
                    </td>
                    <td className="">
                      {d.leaveStatusId === 6 ? (
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-comment">{d.comment}</Tooltip>
                          }
                        >
                          <span
                            style={{
                              color: fnColorStatus(d.leaveStatusId).color,
                              backgroundColor: fnColorStatus(d.leaveStatusId)
                                .bg,
                              padding: '2px 8px 2px 8px',
                              borderRadius: '2rem',
                              fontSize: '14px'
                            }}
                          >
                            {d.leaveStatus}
                          </span>
                        </OverlayTrigger>
                      ) : (
                        <BageStatusCustom
                          id={d.leaveStatusId}
                          name={d.leaveStatus}
                        />
                      )}
                    </td>
                    <td className="text-center">
                      {d.isFile ? (
                        <FaFileAlt
                          size={16}
                          className="pointer-event text-primary"
                          onClick={() => fnGetFile(d.leaveDetailId)}
                        />
                      ) : (
                        '-'
                      )}
                    </td>
                    <td className="text-center">
                      {d.leaveStatusId !== 6 && (
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-detail">Cancel</Tooltip>
                          }
                        >
                          <Button
                            variant="light"
                            className="border-0"
                            size="sm"
                            // style={{
                            //   width: '32px',
                            //   height: '32px'
                            // }}
                            onClick={() =>
                              setShowCancel({ isShow: true, data: d })
                            }
                          >
                            <Image
                              src={cancelImg}
                              style={{
                                width: '20px'
                              }}
                            />
                          </Button>
                        </OverlayTrigger>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-body">
                  <td colSpan={14} className="text-center">
                    -No Data-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRow}
              limit={totalLimits}
              changePage={(p) => {
                const body = {
                  ...bodyFilter,
                  page: p
                }
                fnGetData(body)
                setPage(p)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>

      {showCancel.isShow && (
        <ModalCancel
          fnGetFile={fnGetFile}
          open={showCancel.isShow}
          data={showCancel.data}
          onCancel={() => {
            setShowCancel({ isShow: false, data: null })
          }}
          fnData={() => fnGetData(bodyFilter)}
        />
      )}
    </Row>
  )
}

const BoxFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .from-search {
    flex: 0 0 250px;
  }
  .btn-reflesh {
    flex: 0 0 30px;
  }
  .btn-excel {
    flex: 0 0 30px;
  }
  .btn-status {
    flex: 0 0 150px;
  }
`
